<!-- report_influencer.vue -->
<template>
  <div class="w-100 h-100">
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-show="checkList.length > 0">
      <div class="check-wrap">
        <div class="check-parts" style="color: #666">{{ checkList.length }}件を選択中</div>
        <div
            class="check-parts pointer"
            @click="report_id == 'demo' ? '' : deleteInfluencer()"
            :style="report_id == 'demo' ? 'opacity:0.5' : ''"
        >
          <i class="el-icon-delete" style="font-size: 14px"></i>レポートから削除
        </div>

        <el-tooltip
            v-if="(sns_type || '').toString().toLowerCase() === 'instagram'"
            :disabled="checkList.length < 151 && ig_info != ''">
          <div slot="content">
            {{
              ig_info == ""
                  ? "Instagramアカウントが未連携です"
                  : checkList.length > 150
                      ? "メッセージは150名以上には一斉送信できません"
                      : ""
            }}
          </div>
          <span>
            <el-button
                type="primary"
                size="small"
                @click="newmessage_drawer = true"
                :disabled="checkList.length > 150 || newmessage_drawer || report_id == 'demo'"
            >
              <font-awesome-icon :icon="['fas', 'paper-plane']" style="margin-right: 5px;" />メッセージ
            </el-button>
          </span>
        </el-tooltip>
      </div>
    </div>

    <div class="report-done-switch influencer">
      <div v-if="done_data && result_count >= 0" class="report-influencer-breadcrumb">
        <span class="report-influencer-breadcrumb-num">{{ result_count }}</span>名の投稿済みインフルエンサー /
        <span class="report-influencer-breadcrumb-num">{{ result_count_all }}</span>名中
      </div>

      <div v-else-if="result_count >= 0" class="report-influencer-breadcrumb">
        <span class="report-influencer-breadcrumb-num">{{ all_influencer.length }}</span>名のインフルエンサー
      </div>

      <div class="flex-space"></div>

      <reportDisplayButton :sns_type="sns_type" :list_type="'influencer'" />

      <el-dropdown trigger="click" style="margin-left: 20px">
        <el-button type="info" class="report-media-sort-button" style="width: auto">
          <span v-if="done_data">
            <font-awesome-icon :icon="['far', 'user-check']" style="margin-right: 5px" />投稿済みのインフルエンサーのみ
          </span>
          <span v-else>
            <font-awesome-icon :icon="['far', 'user-friends']" style="margin-right: 5px" />全てのインフルエンサー
          </span>
          <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px" />
        </el-button>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="done_data = false">全てのインフルエンサー</el-dropdown-item>
          <el-dropdown-item @click.native="done_data = true">投稿済みのインフルエンサーのみ</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="data-table-media-wrap">
      <table class="data-table-media">
        <tr v-if="!mounted" class="new-table-title w-100">
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width200"></div>
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width100"></div>
        </tr>

        <tr v-else class="new-table-title">
          <div class="new-table-item checkbox-all">
            <div class="checkbox_inner" :class="check_list_status" @click="checkAll('auto')"></div>

            <el-dropdown trigger="click" placement="bottom-start" @visible-change="checkAll_dropdown = $event">
              <span style="height:20px">
                <div class="checkbox-select-wrap report" :class="checkAll_dropdown ? 'hover' : ''">
                  <font-awesome-icon icon="caret-down" />
                </div>
              </span>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="checkAll('select')">
                  表示中を全て選択({{ influencer_list ? influencer_list.length : "-" }}件)
                </el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('unselect')">
                  表示中を全て選択解除({{ influencer_list ? influencer_list.length : "-" }}件)
                </el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('selectAll')" divided>
                  レポート内の投稿を全て選択({{ all_influencer.length }}件)
                </el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('unselectAll')" v-if="checkList.length > 0">
                  選択中を全て解除({{ checkList.length }}件)
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div
              v-for="(column, column_index) in report_influencer_column"
              v-show="isColumnVisible(column.column)"
              :key="column.column"
              class="new-table-item"
              :class="[
              column.width,
              column_index == 0 ? 'title-sticky-influencer' : '',
              column_index < 1 ? 'nohover' : ''
            ]"
              @click="column_index > 0 && !['average_engagement_impression_rate', 'average_engagement_reach_rate'].includes(column.column) ? sortBy(column.column) : ''"
          >
            <span :class="[sort_key == column.column ? 'new-table-title-sort' : '', column_index == 0 ? 'new-table-title-0' : '']">
              <el-tooltip
                v-if="estimatedEngagementColumnTip(column.column)"
                placement="top"
                :content="estimatedEngagementColumnTip(column.column)"
              >
                <span>
                  {{ column.title }}
                  <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left:3px;" />
                </span>
              </el-tooltip>
              <template v-else>{{ column.title }}</template>
              <font-awesome-icon
                  v-if="sort_key == column.column"
                  :icon="['fas', sort_key == column.column && sort_order == 'asc' ? 'arrow-up' : sort_key == column.column && sort_order == 'desc' ? 'arrow-down' : '']"
                  style="margin-left:3px;"
              />
            </span>
          </div>
        </tr>

        <tr
            class="new-table-content influencer"
            v-for="(influencer, row_index) in influencer_list"
            :key="idKey + ':' + (influencer[idKey] != null ? influencer[idKey] : 'null') + ':' + (influencer.no != null ? influencer.no : row_index)"
        >
          <div class="new-table-item checkbox">
            <input
                type="checkbox"
                class="checkbox-original"
                v-model="checkList"
                :value="influencer[idKey]"
                :id="'cb:' + idKey + ':' + (influencer[idKey] != null ? influencer[idKey] : 'null') + ':' + (influencer.no != null ? influencer.no : row_index)"
                :disabled="influencer[idKey] == null"
            />
            <label
                class="checkbox_inner"
                :class="{ disabled: influencer[idKey] == null }"
                :for="'cb:' + idKey + ':' + (influencer[idKey] != null ? influencer[idKey] : 'null') + ':' + (influencer.no != null ? influencer.no : row_index)"
            ></label>
          </div>

          <reportInfluencerValue
              v-for="(column, column_index) in report_influencer_column"
              v-show="isColumnVisible(column.column)"
              class="new-table-item nohover"
              :class="[column.width, column_index == 0 ? 'sticky' : '']"
              :key="column.column"
              :column="column.column"
              :report_id="report_id"
              :ig_id="influencer[idKey]"
              :index="row_index"
              :value="influencer[column.column]"
              :type="column.type"
              :sns_type="sns_type"
              :is_estimated_engagement_insufficient="influencer.is_estimated_engagement_insufficient === true"
              @openMedia="openMedia"
              @storiesReactive="storiesReactive"
              @openInfluencer="openInfluencer"
          />
        </tr>

        <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </table>
    </div>

    <reportPostDrawer
        v-if="mounted && !loading"
        :report_id="report_id"
        :post_list="post_list"
        :influencer="influencer_info"
        :post_drawer="post_drawer"
        @closeMedia="closeMedia"
        @openInfluencer="openInfluencer"
    />

    <transition name="fade">
      <newmessage
          v-if="newmessage_drawer"
          :newmessage_drawer="newmessage_drawer"
          :recipient="checkListDetail"
          :checkList.sync="checkList"
          :html.sync="html"
          @closeNewmessage="newmessage_drawer = false"
          @clearList="checkList = []"
      />
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadReportInfluencerAPI = root + "/api/report/load_report_influencer";
const deleteInfluencerAPI = root + "/api/report/delete_influencer";

import reportInfluencerValue from "./report_influencer_value.vue";
import reportPostDrawer from "./report_post_drawer.vue";
import reportDisplayButton from "./report_display_button.vue";
import newmessage from "../message/newmessage.vue";

export default {
  name: "reportInfluencer",
  props: ["report_id", "sns_type"],
  components: {
    reportInfluencerValue,
    reportPostDrawer,
    reportDisplayButton,
    newmessage,
  },
  data() {
    return {
      mounted: false,
      loading: false,
      checkList: [],
      checkListDetail: [],
      checkAll_dropdown: false,
      all_influencer: [],
      influencer_list: [],
      column_list: [], // backend column_list（メタ参照用に保持）
      infiniteId: +new Date(),
      requestId: +new Date(),
      count: 0,
      sort_key: "followers_count",
      sort_order: "desc",
      result_count: -1,
      result_count_all: -1,
      nodata: false,
      done_data: true,
      post_drawer: false,
      post_list: [],
      influencer_info: [],
      influencer_drawer: false,
      newmessage_drawer: false,
      html: "",
      for_dm: {},
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    idKey() {
      const st = (this.sns_type || "").toString();
      if (st === "tiktok") return "tt_id";
      if (st === "x") return "tw_id";
      return "ig_id";
    },
    token() {
      return this.$store.state.token;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    item() {
      const st = (this.sns_type || "").toString().toLowerCase() === "tiktok"
          ? "tiktok"
          : ((this.sns_type || "").toString().toLowerCase() === "x" || (this.sns_type || "").toString().toLowerCase() === "twitter")
              ? "x"
              : "instagram";

      return this.$store.state.report_item_map?.influencer?.[st] || {};
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    check_list_status() {
      if (!this.influencer_list.length) return "none";

      let checkCount = 0;
      for (let i = 0; i < this.influencer_list.length; i++) {
        const id = this.influencer_list[i]?.[this.idKey];
        for (let ii = 0; ii < this.checkList.length; ii++) {
          if (id == this.checkList[ii]) checkCount += 1;
        }
      }

      if (checkCount === this.influencer_list.length) return "all";
      if (checkCount > 0) return "some";
      return "none";
    },
    report_influencer_column() {
      return this.column_list || [];
    }
  },
  mounted() {
    console.log('props sns_type=', this.sns_type, 'props report_id=', this.report_id);

    this.$nextTick(() => {
      this.infiniteHandler();
      this.$refs.xscroll && (this.$refs.xscroll.style.width = this.$refs.xscroll.parentElement.clientWidth + "px");
    });
  },
  methods: {
    estimatedEngagementColumnTip(columnKey) {
      if (columnKey === "average_engagement_rate") {
        return (
          "エンゲージメント率(EngagementRate)を示しています。\n" +
          "いいね非表示の投稿を含む場合、一部は推定いいねを用いた指標です。"
        );
      }
      if (columnKey === "average_like" || columnKey === "like_count") {
        return (
          "平均いいね数を示しています。\n" +
          "いいね非表示の投稿を含む場合、一部は推定いいねを用いた指標です。"
        );
      }
      return "";
    },
    isColumnVisible(columnKey) {
      if (!this.item) return true;
      const v = this.item[columnKey];
      return v !== false; // undefined / true は表示、false のみ非表示
    },

    infiniteHandler($state) {
      this.nodata = false;
      this.loading = true;

      this.axios.cancel(this.requestId);
      this.requestId += 1;

      const params = new URLSearchParams();
      params.append("report_id", this.report_id == "demo" ? 1 : this.report_id);
      params.append("count", this.count);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("token", this.report_id == "demo" ? "demo" : this.token);
      params.append("done", this.done_data);
      params.append("user_token", this.user_token);
      params.append("sns_type", this.sns_type);

      this.axios
          .post(loadReportInfluencerAPI, params, { requestId: this.requestId })
          .then((response) => {
            this.cancelSource = null;

            if (this.count === 0) {
              this.result_count = response.data.result_count;
              this.result_count_all = response.data.result_count_all;

              // backend column_list は「メタマージ用」に保持
              this.column_list = response.data.column_list || [];

              this.$store.dispatch("setReportColumnList", {
                sns_type: this.sns_type,
                list_type: "influencer",
                column_list: this.column_list,
              });

              this.$store.dispatch("initReportItemsFromColumnList", {
                sns_type: this.sns_type,
                list_type: "influencer",
                column_list: this.column_list,
              });

              this.influencer_list = response.data.influencer_list || [];
              this.all_influencer = response.data.all_influencer || [];
              this.for_dm = response.data.for_dm || {};
              this.count += 20;
              if ($state) $state.loaded();
            } else {
              this.influencer_list = this.influencer_list.concat(response.data.influencer_list || []);
              this.count += 20;
              if ($state) $state.loaded();
            }

            if ($state && this.count >= this.result_count) $state.complete();
            if (this.result_count == 0) this.nodata = true;

            this.loading = false;
            this.mounted = true;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    reload() {
      this.count = 0;
      this.loading = true;
      this.influencer_list = [];
      this.checkList = [];
      this.infiniteId += 1;
    },
    sortBy(sort_key) {
      if (this.sort_key == sort_key) {
        this.sort_order = this.sort_order == "desc" ? "asc" : "desc";
      } else {
        this.sort_key = sort_key;
        this.sort_order = "desc";
      }
      this.reload();
    },
    checkAll(type) {
      if (type == "auto") {
        if (this.check_list_status == "all") type = "unselect";
        if (this.check_list_status == "some") type = "unselect";
        if (this.check_list_status == "none") type = "select";
      }

      if (type == "select") {
        for (let i = 0; i < this.influencer_list.length; i++) {
          const id = this.influencer_list[i]?.[this.idKey];
          if (id == null) continue;
          if (!this.checkList.includes(id)) this.checkList.push(id);
        }
      } else if (type == "unselect") {
        for (let i = 0; i < this.influencer_list.length; i++) {
          const id = this.influencer_list[i]?.[this.idKey];
          if (id == null) continue;
          if (this.checkList.includes(id)) {
            const index = this.checkList.indexOf(id);
            this.checkList.splice(index, 1);
          }
        }
      } else if (type == "selectAll") {
        this.checkList = [];
        this.checkList = this.checkList.concat(this.all_influencer || []);
      } else if (type == "unselectAll") {
        this.checkList = [];
      }
    },
    deleteInfluencer() {
      const num = this.checkList.length;
      const h = this.$createElement;

      this.$msgbox({
        title: "インフルエンサー削除",
        type: "warning",
        message: h("p", null, [
          h("span", null, "レポートからインフルエンサーを削除しますか？"),
          h("br", null, ""),
          h("span", null, "この作業は取り消せません"),
        ]),
        showCancelButton: true,
        confirmButtonText: "削除",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
      }).then(() => {
        const params = new URLSearchParams();
        params.append("report_id", this.report_id);
        params.append("sns_type", this.sns_type);
        params.append("influencer", JSON.stringify(this.checkList));
        params.append("token", this.token);

        this.axios.post(deleteInfluencerAPI, params).then(() => {
          this.reload();
          this.$emit("loadReportDetail");
          this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", num + "名のインフルエンサーをレポートから削除しました", {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "success",
          });
          this.checkList = [];
          this.checkAll_val = false;
        });
      });
    },
    openMedia(index) {
      const row = this.influencer_list[index];
      this.post_list = row?.influencer?.post_list || [];
      this.influencer_info = row?.influencer || [];

      if (this.post_list.length) {
        this.post_drawer = true;
      } else {
        this.$message({
          message: "投稿がありません",
          type: "error",
          offset: 7,
        });
      }
    },
    closeMedia() {
      this.post_drawer = false;
    },
    openInfluencer(account_name, sns_type) {
      const st = (sns_type || this.sns_type || "").toString();
      const sns = (st === "x") ? "twitter" : st; // 画面側が x を使うなら吸収
      this.$emit("openInfluencer", account_name, sns);
    },
    storiesReactive(index) {
      const row = this.influencer_list[index];
      if (!row || !row.influencer) return;
      row.influencer.stories = !row.influencer.stories;
    },
  },
  watch: {
    done_data() {
      this.reload();
    },
    checkList() {
      this.checkListDetail = [];

      for (let i = 0; i < this.checkList.length; i++) {
        const influencer_id = this.checkList[i];
        const st = (this.sns_type || "").toString();
        const isX = st === "x" || st === "twitter";

        if (!this.for_dm || !this.for_dm[influencer_id]) continue;

        const dm = this.for_dm[influencer_id];
        const detail = {
          account_name: dm.account_name,
          name: dm.name,
          badge: dm.badge,

          ig_id: influencer_id,
          tw_id: isX ? influencer_id : null,
          tt_id: st === "tiktok" ? influencer_id : null,

          profile_picture_url: dm.profile_picture_url
              ? dm.profile_picture_url
              : (this.s3BaseUrl ? this.s3BaseUrl + "/profile_picture/" + dm.account_name + ".jpg" : ""),
        };

        this.checkListDetail.unshift(detail);
        if (i >= 149) break;
      }

      this.checkListDetail = this.checkListDetail.reverse();
    },
  },
};
</script>
